import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/giovambattistafazioli/Lavori/Github/react-toggle/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import Toggle from '../src/components/Toggle';
import ReactToggleThemeProvider from '../src/theme/';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "theming"
    }}>{`Theming`}</h1>
    <p>{`This new version allow to change the whole toggle appearance. Now you'll be able to change every single color and size, for each single toggle component of for the whole user interface.`}</p>
    <h2 {...{
      "id": "how-change-the-toggle-appearance"
    }}>{`How change the toggle appearance`}</h2>
    <p>{`You may change the toggle appearance in two way: by using the new props for each single instance of your toggle component, or by using a theme provider.`}</p>
    <h2 {...{
      "id": "new-appearance-props"
    }}>{`New appearance props`}</h2>
    <p>{`You may use the new props to change the appearance for a single instance of component`}</p>
    <Playground __position={0} __code={'<p>Change the background</p>\n<Toggle name=\"t-1\" backgroundColor=\"rgba(0,0,0,1)\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Toggle,
      ReactToggleThemeProvider
    }} mdxType="Playground">
  <p>Change the background</p>
  <Toggle name="t-1" backgroundColor="rgba(0,0,0,1)" mdxType="Toggle" />
    </Playground>
    <Playground __position={1} __code={'<p>Change the background when on</p>\n<Toggle name=\"t-2\" rightBackgroundColor=\"tomato\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Toggle,
      ReactToggleThemeProvider
    }} mdxType="Playground">
  <p>Change the background when on</p>
  <Toggle name="t-2" rightBackgroundColor="tomato" mdxType="Toggle" />
    </Playground>
    <p>{`Now you can also change others appearance properties`}</p>
    <Playground __position={2} __code={'<p>Change the shape</p>\n<Toggle name=\"t-3\" radius=\"3px\" radiusBackground=\"2px\" knobRadius=\"2px\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Toggle,
      ReactToggleThemeProvider
    }} mdxType="Playground">
  <p>Change the shape</p>
  <Toggle name="t-3" radius="3px" radiusBackground="2px" knobRadius="2px" mdxType="Toggle" />
    </Playground>
    <Playground __position={3} __code={'<p>Change the width size</p>\n<Toggle name=\"t-4\" width=\"128px\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Toggle,
      ReactToggleThemeProvider
    }} mdxType="Playground">
  <p>Change the width size</p>
  <Toggle name="t-4" width="128px" mdxType="Toggle" />
    </Playground>
    <Playground __position={4} __code={'<p>Change the height size</p>\n<Toggle name=\"t-4h\" height=\"48px\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Toggle,
      ReactToggleThemeProvider
    }} mdxType="Playground">
  <p>Change the height size</p>
  <Toggle name="t-4h" height="48px" mdxType="Toggle" />
    </Playground>
    <Playground __position={5} __code={'<p>Change the knob size</p>\n<Toggle name=\"t-5\" knobWidth=\"8px\" knobHeight=\"8px\" />\n<Toggle\n  name=\"t-6\"\n  radius=\"3px\"\n  radiusBackground=\"2px\"\n  knobRadius=\"2px\"\n  width=\"128px\"\n  knobWidth=\"50px\"\n/>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Toggle,
      ReactToggleThemeProvider
    }} mdxType="Playground">
  <p>Change the knob size</p>
  <Toggle name="t-5" knobWidth="8px" knobHeight="8px" mdxType="Toggle" />
  <Toggle name="t-6" radius="3px" radiusBackground="2px" knobRadius="2px" width="128px" knobWidth="50px" mdxType="Toggle" />
    </Playground>
    <p>{`You can also change the size and the border`}</p>
    <Playground __position={6} __code={'<p>Change the border size</p>\n<Toggle name=\"t-7\" borderWidth=\"1px\" />\n<Toggle name=\"t-8\" borderWidth=\"3px\" />\n<Toggle name=\"t-9\" borderWidth=\"5px\" />\n<Toggle name=\"t-10\" borderWidth=\"5px\" knobWidth=\"8px\" knobHeight=\"8px\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Toggle,
      ReactToggleThemeProvider
    }} mdxType="Playground">
  <p>Change the border size</p>
  <Toggle name="t-7" borderWidth="1px" mdxType="Toggle" />
  <Toggle name="t-8" borderWidth="3px" mdxType="Toggle" />
  <Toggle name="t-9" borderWidth="5px" mdxType="Toggle" />
  <Toggle name="t-10" borderWidth="5px" knobWidth="8px" knobHeight="8px" mdxType="Toggle" />
    </Playground>
    <p>{`Of course, you can set the knob gap`}</p>
    <Playground __position={7} __code={'<p>Change the border size</p>\n<Toggle name=\"t-11\" borderWidth=\"1px\" knobGap=\"8px\" />\n<Toggle name=\"t-12\" borderWidth=\"3px\" knobGap=\"8px\" />\n<Toggle name=\"t-13\" borderWidth=\"5px\" knobGap=\"8px\" />\n<Toggle\n  name=\"t-14\"\n  borderWidth=\"5px\"\n  knobWidth=\"8px\"\n  knobHeight=\"8px\"\n  knobGap=\"8px\"\n/>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Toggle,
      ReactToggleThemeProvider
    }} mdxType="Playground">
  <p>Change the border size</p>
  <Toggle name="t-11" borderWidth="1px" knobGap="8px" mdxType="Toggle" />
  <Toggle name="t-12" borderWidth="3px" knobGap="8px" mdxType="Toggle" />
  <Toggle name="t-13" borderWidth="5px" knobGap="8px" mdxType="Toggle" />
  <Toggle name="t-14" borderWidth="5px" knobWidth="8px" knobHeight="8px" knobGap="8px" mdxType="Toggle" />
    </Playground>
    <h2 {...{
      "id": "theme-provider"
    }}>{`Theme Provider`}</h2>
    <p>{`Instead of change every single props, you might use the `}<inlineCode parentName="p">{`ReactToggleThemeProvider`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {ReactToggleThemeProvider} from "react-toggle-component";
`}</code></pre>
    <p>{`The current default theme is the following`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`export default {
  version: "1.0.0",
  width: "48px",
  height: "24px",

  borderWidth: "2px",
  borderColor: "#aaa",
  leftBorderColor: "#aaa",
  rightBorderColor: "#3887b7",

  leftBackgroundColor : "#fff",
  rightBackgroundColor : "#fff",
  backgroundColorDisabled : "#eee",

  radius : "256px",
  radiusBackground : "256px",
  knobRadius : "100%",

  knobWidth : "16px",
  knobHeight : "16px",
  knobGap: "4px",

  knobColor: "#aaa",
  leftKnobColor: "#aaa",
  rightKnobColor: "#3887b7",
};
`}</code></pre>
    <Playground __position={8} __code={'<ReactToggleThemeProvider theme={{ leftBackgroundColor: \'tomato\' }}>\n  <div>\n    <p>All toggle children will use the same theme</p>\n    <Toggle name=\"t-p1\" />\n    <Toggle name=\"t-p2\" />\n    <Toggle name=\"t-p3\" />\n    <Toggle name=\"t-p4\" />\n  </div>\n</ReactToggleThemeProvider>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Toggle,
      ReactToggleThemeProvider
    }} mdxType="Playground">
  <ReactToggleThemeProvider theme={{
        leftBackgroundColor: "tomato"
      }} mdxType="ReactToggleThemeProvider">
    <div>
      <p>All toggle children will use the same theme</p>
      <Toggle name="t-p1" mdxType="Toggle" />
      <Toggle name="t-p2" mdxType="Toggle" />
      <Toggle name="t-p3" mdxType="Toggle" />
      <Toggle name="t-p4" mdxType="Toggle" />
    </div>
  </ReactToggleThemeProvider>
    </Playground>
    <p>{`As you can see from the above example, you don't need to write your own custome theme with all properties, you may override one or more properties.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      